'use client'

import { createAppKit } from '@reown/appkit/react'
import { Ethers5Adapter } from '@reown/appkit-adapter-ethers5'
import { MonadTestnet } from './MonadNetwork'
import { type ReactNode } from 'react'

const projectId = '9b10621f3496e755e021db466c483188'

const ethersAdapter = new Ethers5Adapter()
createAppKit({
  adapters: [ethersAdapter],
  projectId,
  networks: [MonadTestnet],
  metadata: {
    name: 'Bubblefi',
    description: 'The Liquidity hub of Monad',
    url: 'https://app.monadex.exchange',
    icons: ['https://app.monadex.exchange/icon.ico']
  },
  features: {
    email: false,
    socials: [],
    history: false,
    emailShowWallets: false,
    swaps: false,
    send: false,
    analytics: false, 
    
  },
  themeVariables: {
    '--w3m-accent': '#836EF9',
    '--w3m-color-mix': '#836EF9',
    '--w3m-color-mix-strength': 40
  }
})

function ContextProvider ({ children }: { children: ReactNode }): JSX.Element {
  return <>{children}</>
}

export default ContextProvider
